import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import ConfigInit from "pages/ConfigInit/Index"
import Invoices from "pages/Invoices"
import RequisitionList from "pages/Requisitions/RequisitionList"
import PropertyList from "pages/Property/PropertyList"
import AreaList from "pages/Areas/AreaList"
import ConfigInitProperty from "pages/ConfigInit/IndexInventory"
import CatTypePropertyList from "pages/CatTypeProperties/CatTypePropertyList"
import ReportProperties from "pages/ReportProperties"
import Brochure from "pages/Brochure"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard/> },
  { path: "/config", component: <ConfigInitProperty/> },
  { path: "/invoices", component: <Invoices/> },
  { path: "/requisitions", component: <RequisitionList/> },

  { path: "/areas", component: <AreaList/> },

  { path: "/properties", component: <PropertyList/> },

  { path: "/type-properties", component: <CatTypePropertyList/> },

  { path: "/report-properties", component: <ReportProperties/> },

  { path: "/brochure", component: <Brochure/> },


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
   {
    path: "/",
    exact: true,
    component: < Navigate to="/config" />,
  }
]

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
]

export { authProtectedRoutes, publicRoutes }

